import { useLocale } from "next-intl";

import { PrimCallout } from "@/shared-web.ui/prim.callout";
import { semanticColor } from "@/shared-web.ui/styles";

import { type ServerDataOutput } from "../data.subscription-data";

interface BuyNowInfoBoxProps {
  className?: string;
  data: ServerDataOutput;
}
const BuyNowInfoBox = (props: BuyNowInfoBoxProps) => {
  const { className, data } = props;

  const locale = useLocale();

  const infoText = data.subscriptionData.subscriptionMeta.buyNowInfo?.[locale]?.trim();

  // Hide the box entirely when no CMS text is set for this locale
  if (!infoText) {
    return null;
  }

  return (
    <PrimCallout.Root
      className={className}
      color={semanticColor.warning}
      variant="surface"
      size="3"
    >
      <PrimCallout.Text size="3" weight="medium">
        {infoText}
      </PrimCallout.Text>
    </PrimCallout.Root>
  );
};

export { BuyNowInfoBox };
